import React from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import classNames from "classnames";

import { StatusMarker } from "../../../../../components/statusMarker";
import { StyledHeading } from "../../../../../components/brief/index.styles";
import { BriefType } from "../../../../../constants/types";
import { selectPageOwnerId } from "../../../../../redux/selectors/root";
import * as authStore from "../../../../auth/store/auth.store";
import { updateBriefName } from "../../../../../redux/actions/commonActions";
import { withShowIf } from "../../../../../components/with-show-if/with-show-If.component";

import { BriefHeaderDataProps } from "./brief-header-data.props";
import { useBriefHeaderDataStyles } from "./brief-header-data.styles";
import { EditInPlace } from "../../../../../components/form-controls/edit-in-place/edit-in-place.component";
import { Title } from "../../../../../components/headers/title/title.component";
import { BasicResourceType } from "../../../../../types/resources/resources.enums";

export const BriefHeaderData = withShowIf((props: BriefHeaderDataProps) => {
  const dispatch = useDispatch();
  const classes = useBriefHeaderDataStyles();

  // @ts-ignore
  const pageOwnerId = useSelector(selectPageOwnerId(props.briefType));
  const userId = useSelector(authStore.getUserId);

  const titleIsEditable = (): boolean => {
    if (props.briefType === BriefType.WORK_ORDER) {
      return false;
    }

    if (props.briefType === BasicResourceType.Flyer) {
      return true;
    }

    return pageOwnerId === userId && props.status === "draft";
  };

  const defaultBriefTitle = (briefType: BriefType | BasicResourceType) => {
    switch (briefType) {
      case BriefType.CAMPAIGN_BRIEF:
        return "New Campaign Brief";
      case BriefType.EXECUTION_BRIEF:
        return "New Multi Channel Brief";
      case BriefType.WORK_ORDER:
        return "New Brief Work Order";
      case BasicResourceType.Flyer:
        return "New Design Layout";
      default:
        return "";
    }
  };

  const title = props.briefName || defaultBriefTitle(props.briefType);
  const titleClasses = classNames({
    [classes.longTitle]: title.length >= 30,
  });

  const endEditingTitle = (value: string) => {
    if (value === props.briefName) {
      return;
    }

    if (props.onChangeName) {
      return props.onChangeName(value);
    }

    dispatch(
      updateBriefName({
        id: props.briefId,
        newBriefName: value,
        briefTemplate: props.briefTemplate,
        briefType: props.briefType as BriefType,
      })
    );
  };

  return (
    <>
      <EditInPlace
        value={props.briefName}
        onChange={endEditingTitle}
        editable={titleIsEditable()}
        render={() => <Title className={titleClasses}>{title}</Title>}
      />
      <StatusMarker showIf={!!props.status} status={props.status!} />
      <StyledHeading>
        {`SAVED ${props.briefOwner.toUpperCase()} ${moment(props.updatedTime)
          .format("HH:mm a MMM DD, YYYY")
          .toUpperCase()}`}
      </StyledHeading>
    </>
  );
});
